// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Badge from 'components/Badge/Badge'

// Redux:
import { closeAccountDropdown, toggleAccountDropdown, updateAccount, showLoginNudgeModal } from 'actions/site'
import {
	requestCurrentPosition,
	setSiteId,
	setTimezoneType,
	getPlacesSearchResults,
	emptyPlacesSearchResults,
	setUserLocation,
	getFullScheduleData
} from 'actions/schedule'

class MyStation extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			searchInput: '',
			showSelectStation: false
		}
	}

	componentDidMount() {
		document.addEventListener( 'mousedown', this.handleClickOutside )
	}

	componentWillUnmount() {
		document.removeEventListener( 'mousedown', this.handleClickOutside )
	}

	handleClickOutside = ( e ) => {
		const { accountDropdownIsOpen, emptyPlacesSearchResults } = this.props

		if ( accountDropdownIsOpen && ! this.accountRef.contains( e.target ) ) {
			this.props.closeAccountDropdown( 'close' )

			this.setState({
				searchInput: ''
			})

			this.props.emptyPlacesSearchResults()
		}
	}

	handleClick = ( e ) => {
		const { accountDropdownIsOpen, emptyPlacesSearchResults } = this.props

		// Reset search on close:
		if ( accountDropdownIsOpen ) {
			this.setState( {
				searchInput: ''
			} )

			this.props.emptyPlacesSearchResults()
		}

		this.props.toggleAccountDropdown()
	}

	handleSelectStationClick = () => {
		this.setState( {
			showSelectStation: true
		} )
	}

	handleSelectedStationClick = () => {
		// Close:
		this.props.closeAccountDropdown( 'close' )

		this.setState( {
			searchInput: '',
			showSelectStation: false
		} )
	}

	handleRequestGeoClick = () => {
		this.props.requestCurrentPosition()
	}

	handleStationClick = ( e ) => {
		const { siteId, setSiteId, getFullScheduleData, closeAccountDropdown, emptyPlacesSearchResults, showLoginNudgeModal } = this.props

		const id = e.target.getAttribute( 'data-id' )
		const playlistTimezone = e.target.getAttribute( 'data-playlist-timezone' )

		setSiteId( id, playlistTimezone )
		getFullScheduleData()

		// Close:
		closeAccountDropdown( 'close' )

		this.setState( {
			searchInput: '',
			showSelectStation: false
		} )

		emptyPlacesSearchResults()

		if ( ! siteId ) {
			showLoginNudgeModal( true )
		}
	}

	handleSearchChange = ( e ) => {
		const value = e.target.value

		this.setState({
			searchInput: value
		})

		if ( value.length > 2 ) {
			this.props.getPlacesSearchResults( value )
		}
	}

	handlePlaceClick = ( e ) => {
		const id = e.currentTarget.getAttribute( 'data-id' )
		const name = e.currentTarget.getAttribute( 'data-name' )
		const lat = e.currentTarget.getAttribute( 'data-lat' )
		const lng = e.currentTarget.getAttribute( 'data-lng' )

		const data = {
			id: id,
			name: name,
			lat: lat,
			lng: lng
		}

		this.props.setUserLocation( data )
	}

	handleTimezoneClick = ( e ) => {
		const id = e.target.getAttribute( 'data-id' )

		this.props.setTimezoneType( id )
	}

	renderBadges = () => {
		const { accountData } = this.props
		let badgesMarkup

		if ( accountData && accountData.badges && Object.keys( accountData.badges ).length ) {
			badgesMarkup = Object.keys( accountData.badges ).map( key => {
				return <Badge key={ key } badgeId={ key } isMini={ true } />
			} )
		}

		return (
			<div className="-badges">
				{ badgesMarkup }
			</div>
		)
	}

	render() {
		const { location, userLocation, siteId, timezoneType, playlistTimezone, stationsCloseToLocation, placesSearchResults, stationsById, accountDropdownIsOpen, requestedAccountData, accountData } = this.props
		const { searchInput } = this.state
		let { showSelectStation } = this.state
		const wrapClass = accountDropdownIsOpen ? 'is-open account-wrap' : 'account-wrap'
		let stationsMarkup = ''
		let placesMarkup = ''
		let selectedStationMarkup = ''
		let selectedPlaceMarkup = ''
		let showSelectedStation = false

		if ( ! siteId || ( ! userLocation || ! userLocation.id ) ) {
			showSelectStation = true
		}

		// if ( 'AICE' == siteId || 'AVST' == siteId ) {
		// 	showSelectedStation = false
		if ( siteId && stationsById && stationsById[ siteId ] ) {
			showSelectedStation = true
		}

		stationsMarkup = stationsCloseToLocation.length > 0 ? stationsCloseToLocation.map( ( e ) => {
			let className = e.id == siteId ? '-station is-selected' : '-station'

			// Skip the selected station:
			if ( e.id == siteId ) {
				return null
			}

			return (
				<div
					key={ e.id }
					className={ className }
					data-id={ e.id }
					data-playlist-timezone={ e.timezone }
					onClick={ this.handleStationClick }
				>
					{ e.name } { e.freq_fm }

					{ e.id == siteId &&
						<i className="icon-radio-waves" aria-hidden="true"></i>
					||
						<i className="not-checked" aria-hidden="true"></i>
					}
				</div>
			)
		} ) : ''

		if ( showSelectedStation ) {
			selectedStationMarkup = (
				<div className="-station is-selected" onClick={ this.handleSelectedStationClick }>
					<div className="-text">
						{ stationsById[ siteId ].name } { stationsById[ siteId ].freq_fm }
					</div>

					<i className="icon-radio-waves" aria-hidden="true"></i>
				</div>
			)
		}

		if ( userLocation && userLocation.id ) {
			selectedPlaceMarkup = (
				<div key={ userLocation.id } className="-station is-selected">
					<div className="-text">
						<span>Near</span> { userLocation.name }
					</div>

					<i className="icon-target-two" aria-hidden="true"></i>
				</div>
			)
		}

		placesMarkup = placesSearchResults && placesSearchResults.map( ( e ) => {
			let className = userLocation.id == e.id ? '-station is-selected' : '-station'

			return (
				<div
					key={ e.id }
					className={ className }
					data-id={ e.id }
					data-name={ e.name }
					data-lat={ e.lat }
					data-lng={ e.lng }
					onClick={ this.handlePlaceClick }
				>
					<div className="-text">
						<span>Near</span> { e.name }
					</div>

					{ userLocation.id == e.id &&
						<i className="icon-target-two" aria-hidden="true"></i>
					||
						<i className="not-checked" aria-hidden="true"></i>
					}
				</div>
			)
		} ) || ''

		const iceClass = 'AICE' == siteId ? '-station is-selected' : '-station'
		const vastClass = 'AVST' == siteId ? '-station is-selected' : '-station'
		const userTimezoneClass = 'user' == timezoneType ? '-option is-selected' : '-option'
		const localTimezoneClass = 'local' == timezoneType ? '-option is-selected' : '-option'

		return (
			<div className={ wrapClass } ref={ ( e ) => { this.accountRef = e } }>
				<div className="account" onClick={ this.handleClick } ref={ ( e ) => { this.accountLinkRef = e } }>
					<span className="-my">My Faith FM</span>

					<div className="-avatar">
						{/*<i className="icon-radio-waves" aria-hidden="true"></i>*/}

						{ accountData && accountData.picture &&
							<img src={ accountData.picture } alt={ accountData.name } />
						||
							<img src={ `${siteData.images_url}people/default.png` } alt="" />
						}
					</div>
				</div>

				<div className="-dropdown">
					{ ( ! accountData || ! accountData.email ) &&
						<div className="-user">
							<div className="-login-note">
								Create an account for greater access to content.
							</div>

							<a href="/signin" className="button -small">Log in</a>
						</div>
					}

					{ accountData && accountData.email &&
						<div className="-user">
							<div className="-info">
								<div className="-name-badges">
									<Link to="/profile" onClick={ this.handleClick }>{ accountData.name }</Link>
									{ this.renderBadges() }
								</div>

								<div className="-edit">
									<Link to="/profile" onClick={ this.handleClick }>My profile</Link>
									<span className="-divider">/</span>
									<a href="/signout">Log out</a>
								</div>
							</div>
						</div>
					}

					<div className="-stations">
						{ userLocation && userLocation.id &&
							<div>
								<div className="-heading-main">
									My station
								</div>

								{ showSelectStation &&
									<div className="-pre-text">
										Choose a station for correct program times and access to regional content.
									</div>
								}

								{ selectedStationMarkup }

								{ ! showSelectStation &&
									<div className="-station" onClick={ this.handleSelectStationClick }>
										Change station

										<i className="icon-radio-waves" aria-hidden="true"></i>
									</div>
								}

								{ showSelectStation &&
									<div>
										{ stationsMarkup }

										{ 'AICE' != siteId &&
											<div
												className={ iceClass }
												data-id="AICE"
												data-playlist-timezone="Australia/Sydney"
												onClick={ this.handleStationClick }
											>
												Internet Radio

												<i className="not-checked" aria-hidden="true"></i>
											</div>
										}

										{ 'AVST' != siteId &&
											<div
												className={ vastClass }
												data-id="AVST"
												data-playlist-timezone="Australia/Sydney"
												onClick={ this.handleStationClick }
											>
												Outback Australia - VAST Radio Ch 688

												<i className="not-checked" aria-hidden="true"></i>
											</div>
										}
									</div>
								}
							</div>
						}

						{ showSelectStation &&
							<div>
								<div className="-heading-main">
									Find station
								</div>

								{ ( ! userLocation || ! userLocation.id ) &&
									<div className="-pre-text">
										Choose a station for correct program times and access to regional content.
									</div>
								}

								{ selectedPlaceMarkup }

								<div className="-search">
									<i className="icon-search" aria-hidden="true"></i>

									<input type="text" placeholder="Search by location" value={ searchInput } onChange={ this.handleSearchChange } />
								</div>

								<div className="-geo" onClick={ this.handleRequestGeoClick }>
									<i className="icon-target-two" aria-hidden="true"></i> Get my current location
								</div>

								{ placesMarkup.length > 0 &&
									<div className="-heading">
										Results
									</div>
								}

								{ placesMarkup }
							</div>
						}
					</div>

					<div className="-timezone">
						<div className="-text">
							Show times for
						</div>

						<div className="-timezone-options">
							<div
								className={ userTimezoneClass }
								data-id="user"
								onClick={ this.handleTimezoneClick }
							>
								My timezone
							</div>

							<div className="-divider">/</div>

							<div
								className={ localTimezoneClass }
								data-id="local"
								onClick={ this.handleTimezoneClick }
							>
								Station timezone
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		siteId: state.schedule.siteId,
		userLocation: state.schedule.userLocation,
		timezoneType: state.schedule.timezoneType,
		playlistTimezone: state.schedule.playlistTimezone,
		placesSearchResults: state.schedule.placesSearchResults,
		stationsCloseToLocation: state.schedule.stationsCloseToLocation,
		stationsById: state.schedule.stationsById,
		accountDropdownIsOpen: state.site.accountDropdownIsOpen,
		requestedAccountData: state.site.requestedAccountData,
		accountData: state.site.accountData
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		closeAccountDropdown() {
			dispatch( closeAccountDropdown() )
		},

		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		},

		requestCurrentPosition() {
			dispatch( requestCurrentPosition() )
		},

		setSiteId( id, playlistTimezone ) {
			dispatch( setSiteId( id, playlistTimezone ) )
			dispatch( updateAccount( {
				site_id: id
			} ) )
		},

		setUserLocation( data ) {
			dispatch( setUserLocation( data ) )
			dispatch( updateAccount( {
				site_search: data
			} ) )
		},

		setTimezoneType( value ) {
			dispatch( setTimezoneType( value ) )
			dispatch( updateAccount( {
				timezone_type: value,
				user_timezone_offset: new Date().getTimezoneOffset()
			} ) )
		},

		getPlacesSearchResults( search ) {
			dispatch( getPlacesSearchResults( search ) )
		},

		emptyPlacesSearchResults() {
			dispatch( emptyPlacesSearchResults() )
		},

		getFullScheduleData() {
			dispatch( getFullScheduleData() )
		},

		showLoginNudgeModal( value ) {
			dispatch( showLoginNudgeModal( value ) )
		}
	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps, null, { pure: false } )( MyStation )
)
